import { MY_FLEET_STATE } from "features/myFleet/constants";
import { useSelector } from "react-redux";
import { RootState } from "store";

export const useGetFilter = () => {
  const myFleetFilter = useSelector(
    (state: RootState) => state[MY_FLEET_STATE].filter
  );
  return myFleetFilter;
};

export const useIsEmptyFilter = () => {
  const myFleetFilter = useSelector(
    (state: RootState) => state[MY_FLEET_STATE].filter
  );
  const isEmptyFilter = Object.keys(myFleetFilter).every((key) => {
    if (key === "locationStatus" || key === "deviceType") {
      return Object.keys(myFleetFilter[key]).length === 0;
    }
    return true;
  });

  return isEmptyFilter;
};
